export const STEP_TITLES = {
  DETAILS: 'Details',
  QUESTIONS: 'Questions',
  NARRATIVE: 'Narrative',
  FINISH: 'Finish',
}

export const STEP_IDS = {
  DETAILS: 1,
  QUESTIONS: 2,
  NARRATIVE: 3,
  FINISH: 4,
} as const

export const SPECIAL_REPORTS_STEPS = [
  {
    id: STEP_IDS.DETAILS,
    title: STEP_TITLES.DETAILS,
  },
  {
    id: STEP_IDS.QUESTIONS,
    title: STEP_TITLES.QUESTIONS,
  },
  {
    id: STEP_IDS.NARRATIVE,
    title: STEP_TITLES.NARRATIVE,
  },
  {
    id: STEP_IDS.FINISH,
    title: STEP_TITLES.FINISH,
  },
]
